module.exports = __webpack_public_path__ + "img/syl_gallery9.20a3fcfb.jpg";